'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fill2 = require('./_internal/_fill');

var _fill3 = _interopRequireDefault(_fill2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _reverse = require('./reverse');

var _reverse2 = _interopRequireDefault(_reverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fillBy = (0, _reverse2.default)(_fill3.default, _INT_TWO2.default); /**
                                                                         * Fill an array with a defined value
                                                                         *
                                                                         * @module fillBy
                                                                         * @func
                                                                         * @since 1.17.0
                                                                         * @param {val} val
                                                                         * @param {Array} arr
                                                                         * @return {function|arr}
                                                                         * @example
                                                                         *
                                                                         *     fillBy(1, [undefined, undefined]); //=> [1, 1]
                                                                         *     fillBy(2)([undefined, undefined); //=> [2, 2]
                                                                         */

exports.default = fillBy;